<template>
	<div class="flow-run-container width-100 height-100" :class="{ 'is-active': isActive }">
		<FlowRun v-on="$listeners" inAppMode :hashId="hashId" />
	</div>
</template>

<script>
import FlowRun from '@/views/FlowRun/FlowRun.vue';
export default {
	name: 'InAppFlowRun',
	props: { hashId: { type: String }, isActive: { type: Boolean } },
	components: { FlowRun },
	computed: {},
	methods: {},
	created() {},
	data() {
		return {};
	},
};
</script>

<style scoped lang="scss">
.flow-run-container {
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 3;
	position: fixed;
	background: var(--faded-background);
}
.is-active {
	::v-deep {
		.widget-form {
			height: 100%;
			align-items: center;
			justify-content: center;
		}
	}
}
</style>
